import type { CSSProperties } from "react";

type RulebookLevelSegmentsProps = {
  segments: { weight: number }[];
  color?: string;
  "data-testid"?: string;
};

const MINIMUM_SEGMENT_OPACITY = 0.35;
const SEGMENT_OPACITY_RANGE = 0.65;

const getSegmentOpacity = ({ index, count }: { index: number; count: number }): number =>
  MINIMUM_SEGMENT_OPACITY + SEGMENT_OPACITY_RANGE * ((index + 1) / count);

const getSegmentStyle = ({ weight, index, count }: { weight: number; index: number; count: number }): CSSProperties => ({
  flexGrow: weight,
  opacity: getSegmentOpacity({ index, count }),
});

const RulebookLevelSegments = ({ segments, color, "data-testid": testId }: RulebookLevelSegmentsProps) => {
  const rootStyle = color ? { color } : undefined;
  const segmentStyles = segments.map(({ weight }, index) => getSegmentStyle({ weight, index, count: segments.length }));

  return (
    <div className="flex h-1.5 gap-px overflow-hidden rounded-full" style={rootStyle} data-testid={testId}>
      {segmentStyles.map((segmentStyle, index) => (
        <span key={index} className="bg-current" style={segmentStyle} data-testid={testId ? `${testId}-Segment-${index}` : undefined} />
      ))}
    </div>
  );
};

export default RulebookLevelSegments;
